import { Card, Typography, Progress, List } from "antd";

const { Text } = Typography;

const SeoPreviewCard = ({ metaData, seoScore }) => {
	const { metaTitle, metaDescription, urlSlug, focusKeywords, ogImage } =
		metaData;
	const { suggestions, score } = seoScore;

	// Highlight focus keywords in the description
	const highlightKeywords = (text, keywords) => {
		if (!keywords || !text) return text;
		const words = keywords.split(",").map((kw) => kw.trim());
		const regex = new RegExp(`\\b(${words.join("|")})\\b`, "gi");
		return text.split(regex).map((part, index) =>
			words.includes(part.toLowerCase()) ? (
				<strong key={index} style={{ color: "#d32f2f" }}>
					{part}
				</strong>
			) : (
				part
			)
		);
	};

	return (
		<Card
			bordered={false}
			style={{
				background: "#f9f9f9",
				padding: 16,
				borderRadius: 6,
				marginBottom: "20px",
			}}
		>
			<Text strong>SEO Overview</Text>

			{/* SEO Score Progress */}
			<Progress
				percent={score}
				status={score > 60 ? "success" : "warning"}
				strokeColor={score > 60 ? "#52c41a" : "#faad14"}
				style={{ margin: "10px 0" }}
			/>

			{/* Live Preview */}
			<div style={{ marginTop: 8 }}>
				<Text style={{ color: "#1a0dab", fontSize: 16 }}>
					{metaTitle || "Untitled Product"}
				</Text>
				<br />
				<Text style={{ color: "#006621", fontSize: 14 }}>
					{`https://yourstore.com/${urlSlug || "your-product"}`}
				</Text>
				<br />
				<Text type="secondary" style={{ fontSize: 14 }}>
					{highlightKeywords(
						metaDescription || "No description available.",
						focusKeywords
					)}
				</Text>

				{/* OG Image Preview */}
				{ogImage && (
					<div style={{ marginTop: 12 }}>
						<img
							src={ogImage}
							alt="OG Preview"
							style={{
								width: "100%",
								maxWidth: 400,
								borderRadius: 6,
								marginTop: 8,
							}}
						/>
					</div>
				)}
			</div>

			{/* SEO Suggestions */}
			{suggestions?.length > 0 && (
				<div style={{ marginTop: 16 }}>
					<Text strong>Suggestions to Improve SEO:</Text>
					<List
						size="small"
						bordered
						dataSource={suggestions}
						renderItem={(item) => <List.Item>✅ {item}</List.Item>}
						style={{ marginTop: 8 }}
					/>
				</div>
			)}
		</Card>
	);
};

export default SeoPreviewCard;
